import { queryOptions } from '@tanstack/react-query'

import { announcementsApi } from './announcements.api'

export const announcementQueryKeys = {
  all: ['announcements'] as const,
  today: (date: string) => [...announcementQueryKeys.all, 'today', date] as const,
}

export const announcementQueries = {
  /**
   * The unseen announcements of a local calendar day. Always asked afresh (at
   * app start and on every return to the tab); checks that overlap share one
   * request.
   */
  today: (date: string) =>
    queryOptions({
      queryKey: announcementQueryKeys.today(date),
      queryFn: () => announcementsApi.today(date),
      staleTime: 0,
      retry: false,
    }),
}
